import { useEffect, useSyncExternalStore } from "react";

// The livery of the page currently on screen (see LIVERY_OPTIONS in
// profileCustomizationOptions.js). Only an artist profile sets one; every
// other page is "none". It lives outside React state because the site
// Header - rendered above the routes, not inside the profile - restyles
// itself to match while a liveried profile is open.

let current = "none";
const listeners = new Set();

// Desktop '95 uses a pixel font. Only fetched the first time a profile with
// that livery is opened, so nobody else downloads it.
const LIVERY_FONTS = {
  desktop95: "https://fonts.googleapis.com/css2?family=Pixelify+Sans:wght@400;500;600;700&display=swap",
};

function loadLiveryFont(id) {
  const href = LIVERY_FONTS[id];
  if (!href || document.querySelector(`link[data-livery-font="${id}"]`)) return;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = href;
  link.dataset.liveryFont = id;
  document.head.appendChild(link);
}

function setPageLivery(id) {
  if (id === current) return;
  current = id;
  // Mirrored onto <body> so page-level backgrounds outside the profile
  // (behind short pages, overscroll) match - see artistLiveries.css.
  if (id === "none") delete document.body.dataset.livery;
  else document.body.dataset.livery = id;
  loadLiveryFont(id);
  listeners.forEach((fn) => fn());
}

function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function usePageLivery() {
  return useSyncExternalStore(subscribe, () => current, () => "none");
}

// Called by the artist profile: applies its livery while mounted and resets
// to "none" on the way out, so the next page gets the normal header back.
export function useApplyPageLivery(id) {
  useEffect(() => {
    setPageLivery(id || "none");
    return () => setPageLivery("none");
  }, [id]);
}
